import React from 'react';
import PropTypes from 'prop-types';
import { useUser } from '@lore/auth';
import { Helmet } from 'react-helmet-async';
import PageHeader from '@/pages/people-people/PageHeader';
import OptionCard from '@/pages/my-network/OptionCard';
import queryString from 'query-string';
import Images from '@/constants/Images';
import Recommended from './Recommended';

function Header(props) {
  const { children } = props;

  return (
    <div className="p-8 space-y-8">
      <Helmet>
        <title>Explore opportunities</title>
      </Helmet>
      <PageHeader
        title="Explore opportunities"
        subtitle={(
          <>
            Check out the active projects and events where educators are seeking
            collaborators. Explore exciting offers created by partners for educators
            and learners.
          </>
        )}
      />
      <div className="space-y-8">
        {children}
      </div>
    </div>
  );
}

Header.propTypes = {
  children: PropTypes.node.isRequired
};

window.stringify = queryString.stringify;

export default function Layout() {
  const currentUser = useUser();

  return (
    <Header currentUser={currentUser}>
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
        <OptionCard
          imageUrl={Images.ACTIVE_PROJECTS}
          title="Explore active projects and events"
          subtitle="Discover projects and events where educators are seeking partners."
          linkText="Explore"
          to="/projects-events-populate"
        />
        <OptionCard
          imageUrl={Images.ACTIVE_OFFERS}
          title="Discover offers for educators and learners"
          subtitle="Take a look at the offers in your community."
          linkText="Discover"
          to="/offers-populate"
        />
      </div>
      <Recommended />
    </Header>
  );
}
